import { render, staticRenderFns } from "./CustomAdd.vue?vue&type=template&id=4ffe490d&scoped=true&"
import script from "./CustomAdd.vue?vue&type=script&lang=js&"
export * from "./CustomAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomAdd.vue?vue&type=style&index=0&id=4ffe490d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe490d",
  null
  
)

export default component.exports